import React from "react";

export default function PreloaderLine({ size, sections }) {
  return (
    <div className={`pre-line ${size}`}>
      {[...Array(sections)].map((_, index) => (
        <div className="sec shine" key={index} />
      ))}
    </div>
  );
}
